module.exports = __webpack_public_path__ + "img/frame (242).2dd96b94.jpg";